import { FC, Fragment } from "react";
import {
  Button,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {
  AutoFixHighOutlined,
  NotificationsActiveOutlined,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import { getUserPermissionInfoText } from "../../../../utils/helpers/getUserPermissionInfoText";
import { workflowsActionSearchParamKey } from "../utils/constants/constants";
import { useAppAbility } from "@/services/permissions";
import { useMenuHook } from "@/utils/hooks/useMenu.hook";

export const WorkflowCreateButton: FC = () => {
  const { anchor, open, openMenu, closeMenu } = useMenuHook();
  const { cannot } = useAppAbility();
  const canNotCreateSchedule = cannot("create", "schedule");

  const userPermissionTooltipText = canNotCreateSchedule
    ? getUserPermissionInfoText("Create Workflow")
    : "";

  return (
    <Fragment>
      <Tooltip arrow title={userPermissionTooltipText}>
        <span>
          <Button
            color="primary"
            size="small"
            variant="outlined"
            onClick={openMenu}
            disabled={canNotCreateSchedule}
            startIcon={<AddIcon />}
          >
            Create Workflow
          </Button>
        </span>
      </Tooltip>

      <Menu
        open={open}
        onClose={closeMenu}
        anchorEl={anchor}
        MenuListProps={{
          sx: {
            width: anchor?.clientWidth,
          },
        }}
      >
        <MenuItem
          component={Link}
          to={`${path}?${workflowsActionSearchParamKey}=clean_and_notify`}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <AutoFixHighOutlined fontSize="small" />
            <Typography variant="body2">Take Action</Typography>
          </Stack>
        </MenuItem>
        <MenuItem
          component={Link}
          to={`${path}?${workflowsActionSearchParamKey}=notify`}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <NotificationsActiveOutlined fontSize="small" />
            <Typography variant="body2">Notify Only</Typography>
          </Stack>
        </MenuItem>
      </Menu>
    </Fragment>
  );
};

const path = "/automations/workflow/create";
